export default __webpack_public_path__ + "static/media/rank-5.22d0d5c9.svg";